var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, reaction } from "mobx";
import { FormModel } from "../FormModel";
import { colors } from "healthex-common/colors";
export class AddJoinCommonRequirementsWizardViewModel {
    constructor(container, uiManager, viewType, initialPage, initialFormInput) {
        this.disposers = [];
        this.progressBars = [5, 0, 0];
        this.updateIntervals = [];
        this.processingApisDone = false;
        this.container = container;
        this.uiManager = uiManager;
        this.viewType = viewType;
        this.currentPage = initialPage;
        this.formModel = new FormModel(initialFormInput, []);
    }
    run() {
        this.disposers.push(reaction(() => this.dialogTitleInfo, () => {
            this.uiManager.updateDialogTitleInfo(this.dialogTitleInfo);
        }, { fireImmediately: true }));
        this.disposers.push(reaction(() => this.currentPage, () => {
            this.uiManager.updateCurrentPage(this.currentPage);
        }, { fireImmediately: true }));
    }
    stop() {
        this.uiManager.updateDialogTitleInfo(null);
        this.uiManager.updateCurrentPage(null);
        this.clearProgressBarIntervalsIfNeeded();
        this.disposers.forEach((disposer) => disposer());
        this.disposers = [];
    }
    clearProgressBarIntervalsIfNeeded() {
        this.updateIntervals.forEach((intervalId) => {
            clearInterval(intervalId);
        });
        this.updateIntervals = [];
    }
    get currentPageIndex() {
        return this.pages.indexOf(this.currentPage);
    }
    goToPreviousPage() {
        if (this.currentPageIndex <= 0)
            return;
        this.currentPage = this.pages[this.currentPageIndex - 1];
    }
    setProgress(index, value) {
        this.progressBars[index] = value > 100 ? 100 : value;
    }
    startProgressBar(index) {
        const updateRate = [500, 1500, 3000];
        const maxProgress = index === 2 ? 90 : 100;
        clearInterval(this.updateIntervals[index]);
        this.updateIntervals[index] = window.setInterval(() => {
            if (this.progressBars[index] < maxProgress) {
                this.setProgress(index, this.progressBars[index] + 5);
            }
            else if (index === 2 && !this.processingApisDone) {
                this.setProgress(index, 90);
                clearInterval(this.updateIntervals[index]);
            }
            else {
                clearInterval(this.updateIntervals[index]);
                if (index + 1 < this.progressBars.length) {
                    this.startProgressBar(index + 1);
                }
            }
        }, updateRate[index]);
    }
    getUploadingProgressBarBackgroundColor() {
        return colors.accents_sunset;
    }
    getExtractingProgressBarBackgroundColor() {
        return colors.accents_grass;
    }
    getProcessingProgressBarBackgroundColor() {
        return colors.accents_sun;
    }
    clearProtocolDocumentProgressIntervals() {
        this.progressBars.forEach((_, index) => clearInterval(this.updateIntervals[index]));
    }
    clearProtocolDocumentProgress() {
        this.progressBars.forEach((_, index) => this.setProgress(index, 0));
    }
}
__decorate([
    observable,
    __metadata("design:type", FormModel)
], AddJoinCommonRequirementsWizardViewModel.prototype, "formModel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddJoinCommonRequirementsWizardViewModel.prototype, "viewType", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddJoinCommonRequirementsWizardViewModel.prototype, "currentPage", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AddJoinCommonRequirementsWizardViewModel.prototype, "progressBars", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddJoinCommonRequirementsWizardViewModel.prototype, "processingApisDone", void 0);
